import React, { useRef, useState, useEffect } from 'react';
import {
  Button,
  Col,
  Collapse,
  Layout,
} from 'antd';
import HeaderLanding from './staticsHeader';
import { ReactComponent as Man } from '../../../assets/icons/man-img.svg';
import { ReactComponent as Sbgrowth } from '../../../assets/icons/sbgrowth.svg';
import { ReactComponent as Laptop } from '../../../assets/icons/laptop.svg';
import { ReactComponent as Minus } from '../../../assets/icons/minus.svg';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
import Footer from './staticFooter';
import { useNavigate, useLocation } from 'react-router-dom';

const { Content } = Layout;
const { Panel } = Collapse;

const StaticPage1 = () => {
  const [activeKey, setActiveKey] = useState();
  const navigate = useNavigate();
  const myRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <Layout id="landing-page">
      <HeaderLanding
        className="header-landing"
      />
      <Content>
        <div className='landing-layout'>
          <div className='landing-first-quarter'>
            <div className='left-half'>
              <Sbgrowth></Sbgrowth>
              <p className='first-text'>
                Χρηματοδότηση πολύ μικρών και μικρών επιχειρήσεων από το Ταμείο Ανάκαμψης και Ανθεκτικότητας
              </p>
              <p className='second-text'>
                Δημιούργησε εύκολα και γρήγορα το επιχειρηματικό σου σχέδιο για τη χρηματοδότηση των <b>επενδύσεων σου</b>, μέσω των δανείων που προσφέρει το <b>Ταμείο Ανάκαμψης και Ανθεκτικότητας.</b>
              </p> 
              <p className='second-text'> 
                Ξέχνα τις πολύπλοκες διαδικασίες και επένδυσε τώρα στο μέλλον της επιχείρησής σου!
              </p>
              <div className='buttons-wrapper'>
                <Button onClick={()=>navigate('/login')} className='left-button' id='static-btn' ><span className='left-button-span'>Είσοδος στην πλατφόρμα</span></Button>
                <Button onClick={()=>myRef.current.scrollIntoView()} className='right-button' id='static-btn'><span className='right-button-span'>Ποια είναι η Διαδικασία;</span></Button>
              </div>
            </div>
            <div className='right-half'>
              <Man></Man>
            </div>
          </div>

          <div className='grey-wrapper'>
            <div className='landing-second-quarter'>
              <div className='second-quarter-texts' ref={myRef}>
                <span className='second-quarter-first-text'>
                  Γνωρίστε την διαδικασία
                </span>
                <span className='second-quarter-second-text'>
                  Πώς λειτουργεί η διαδικασία 
                </span>
                <span className='second-quarter-third-text'>
                  Είσαι ιδιοκτήτης πολύ μικρής ή μικρής επιχείρησης; Δες πώς μπορείς να χρηματοδοτήσεις τα επενδυτικά σχέδια της επιχείρησής σου σε 4 απλά βήματα.
                </span>
              </div>
              <div className='steps-row'>
                <div className='step-container'>
                  <div className='step-header'>
                    <div className='step-number'>
                      <span className='step-number-span'>1</span>
                    </div>
                    <div className='step-title'>
                      <span className='step-title-span'>Είσοδος με Taxisnet</span>
                    </div>
                  </div>
                  <div className='step-content-wrapper'>
                    <div className='step-content'>
                      <span>
                        Κάνε είσοδο στην πλατφόρμα μέσω <b>Taxis Login,</b> χρησιμοποιώντας τα credentials σου, για <b>ασφαλή ταυτοποίηση</b> και <b>αυτόματη εισαγωγή</b> όλων των απαραίτητων στοιχείων για την αίτηση. Συγκεκριμένα:
                      </span>
                      <br></br>
                      <div className='ml-2'>
                      <li>
                        Βασικά Στοιχεία Επιχείρησης 
                      </li>
                      <li>
                        Στοιχεία Έδρας
                      </li>
                      <li>                    
                        Στοιχεία Εισοδήματος
                      </li>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='step-container'>
                  <div className='step-header'>
                    <div className='step-number'>
                      <span className='step-number-span'>2</span>
                    </div>
                    <div className='step-title'>
                      <span className='step-title-span'>Εισαγωγή Δαπανών Επένδυσης</span>
                    </div>
                  </div>
                  <div className='step-content-wrapper'>
                    <div className='step-content'>
                      <span>
                        <b>Ανέβασε τις δαπάνες σου</b> για <b>άμεσο, αυτοματοποιημένο έλεγχο επιλεξιμότητας</b> – εύκολα, γρήγορα & χωρίς κόπο! 
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='steps-row'>
                <div className='step-container-2'>
                  <div className='step-header'>
                    <div className='step-number'>
                      <span className='step-number-span'>3</span>
                    </div>
                    <div className='step-title'>
                      <span className='step-title-span'>Αυτοματοποιημένη Δημιουργία Επενδυτικού Σχεδίου</span>
                    </div>
                  </div>
                  <div className='step-content-wrapper'>
                    <div className='step-content'>
                      <span>
                        Ολοκληρωμένο Επενδυτικό Σχέδιο με ένα κλικ!
                      </span>
                      {/* <br></br> */}
                      <span>
                        <b>Αναλαμβάνουμε την επεξεργασία των δεδομένων σου</b> και δημιουργούμε αυτόματα ένα πλήρες επενδυτικό σχέδιο, έτοιμο για υποβολή!
                      </span>
                    </div>
                  </div>
                </div>
                <div className='step-container-2'>
                  <div className='step-header'>
                    <div className='step-number'>
                      <span className='step-number-span'>4</span>
                    </div>
                    <div className='step-title'>
                      <span className='step-title-span'>Υποβολή στα Δάνεια ΤΑΑ</span>
                    </div>
                  </div>
                  <div className='step-content-wrapper'>
                    <div className='step-content'>
                      <span>
                        Πραγματοποίησε την τελική προεπισκόπηση της αίτησής σου και υπέβαλε την εύκολα στα δάνεια ΤΑΑ.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='landing-third-quarter'>
            <Col className='first-landing-column'>
              <label className='landing-third-quarter-title'>Τι κερδίζω;</label>
              <p className='landing-third-quarter-subtitle'>
                Ποια είναι τα οφέλη για την επιχείρησή σου;
              </p>
              <div className='laptop-wrapper'>
                <Laptop></Laptop>
              </div>
            </Col>
            <Col>
              <div className='landing-column'>
                <div className='landing-column-content'>
                  <div className='column-labels-wrapper'>
                    <label className='columns-label'>Ψηφιακή Υποβοήθηση</label>
                  </div>
                  <p className='columns-content'>
                    Εύκολη δημιουργία και κατάθεση των επενδυτικών σου σχεδίων μέσω της υποστήριξης του Center of Excellence και των αυτοματισμών του συστήματος.
                  </p>
                </div>
                <div className='landing-column-content'>
                  <div className='column-labels-wrapper'>
                    <label className='columns-label'>Ασφάλεια Δεδομένων</label>
                  </div>
                  <p className='columns-content'>
                    Εφαρμογή σύγχρονων πρωτοκόλλων κρυπτογράφησης και συμμόρφωση με το GDPR και τους σχετικούς κανονισμούς ασφάλειας δεδομένων.
                  </p>
                </div>
              </div>
              <div className='landing-column'>
                <div className='landing-column-content'>
                  <div className='column-labels-wrapper'>
                    <label className='columns-label'>Αυτοματοποιημένες Διαδικασίες</label>
                  </div>
                  <p className='columns-content'>
                    Γρήγορη και δωρεάν διαδικασία υποβολής αιτήσεων, επιλογής εμπορικών τραπεζών και παρακολούθησης των δαπανών, με τη βοήθεια αυτοματισμών.
                  </p>
                </div>
                <div className='landing-column-content'>
                  <div className='column-labels-wrapper'>
                    <label className='columns-label'>Ευκολότερη Πρόσβαση στο Δανειακό Σκέλος</label>
                  </div>
                  <p className='columns-content'>
                    Εύκολη πρόσβαση της πολύ μικρής ή μικρής επιχείρησής σου στο Ταμείο Ανάκαμψης, ενισχύοντας την οικονομική της ανάπτυξη.
                  </p>
                </div>
              </div>
              <div className='landing-column'>
                <div className='landing-column-content'>
                  <div className='column-labels-wrapper'>
                    <label className='columns-label'>Δωρεάν Χρήση</label>
                  </div>
                  <p className='columns-content'>
                    Μηδενική επιβάρυνση κόστους μέχρι την υπογραφή της δανειακής σου σύμβασης, καθιστώντας όλη τη διαδικασία χρηματοδότησης πιο προσιτή για εσένα.
                  </p>
                </div>
                <div className='landing-column-content'>
                  <div className='column-labels-wrapper'>
                    <label className='columns-label'>Ευνοϊκοί Όροι Χρηματοδότησης</label>
                  </div>
                  <p className='columns-content'>
                    Χρηματοδότηση μέσω δανείων του 80% των επενδυτικών σου σχεδίων με σταθερό επιτόκιο από 0,35% για το 50% των επιλέξιμων δαπανών. 
                  </p>
                </div>
              </div>
            </Col>
          </div>

          
          <div className='grey-wrapper'>
            <div className='landing-fourth-quarter'>
              <div className='collapse-texts-wrapper'>
                <div className='collapse-text'>
                  <text className='collapse-first-text'>Συχνές Ερωτήσεις</text>
                </div>  
                <div className='collapse-text'>
                  <text className='collapse-second-text'>Όλα όσα πρέπει να γνωρίζετε για την διαδικασία</text>
                </div>  
              </div>
              <div className="main-content" id="landing-info">
                <Collapse
                  key="1"
                  className="main-content__collapse"
                  expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                  expandIconPosition={'right'}
                  onChange={e =>
                    activeKey === '1' ? setActiveKey('') : setActiveKey('1')
                  }
                  activeKey={activeKey}
                >
                  {/* <Panel
                    header={
                      <text className='panel-header-title'>
                        Όλα όσα πρέπει να γνωρίζετε για τη διαδικασία
                      </text>
                    }
                    key="1"
                  >
                    <div>
                      <p>
                        Το Πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα»
                        επιχορηγεί νοικοκυριά για την αντικατάσταση ενεργοβόρων
                        ηλεκτρικών θερμοσίφωνων, με νέους σύγχρονης τεχνολογίας
                        ηλιακούς θερμοσίφωνες ή/και με σύστημα αντλίας θερμότητας.
                        Το πρόγραμμα περιλαμβάνει:
                      </p>
                    </div>
                  </Panel> */}
                </Collapse>

                <Collapse
                  key="2"
                  className="main-content__collapse"
                  expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                  expandIconPosition={'right'}
                  onChange={e =>
                    activeKey === '2' ? setActiveKey('') : setActiveKey('2')
                  }
                  activeKey={activeKey}
                >
                  <Panel
                    header={
                      <text className='panel-header-title'>
                        Σκοπός και Αντικείμενο
                      </text>
                    }
                    key="2"
                  >
                    <div>
                      <p>
                        Δυνητικοί ωφελούμενοι του Προγράμματος είναι μικρές και πολύ μικρές επιχειρήσεις 
                        που επιθυμούν να πραγματοποιήσουν επενδύσεις οι οποίες στοχεύουν, μεταξύ άλλων, 
                        στον εκσυγχρονισμό της επιχείρησης, στην ψηφιακή αναβάθμιση, στην υλοποίηση πράσινων παρεμβάσεων και στην βελτίωση της βιωσιμότητας της επιχείρησης.
                      </p>
                    </div>
                  </Panel>
                </Collapse>

                <Collapse
                  key="3"
                  className="main-content__collapse"
                  expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                  expandIconPosition={'right'}
                  onChange={e =>
                    activeKey === '3' ? setActiveKey('') : setActiveKey('3')
                  }
                  activeKey={activeKey}
                >
                  <Panel
                    header={
                      <text className='panel-header-title'>Τι συμβαίνει αν η αίτησή μου απορριφθεί;</text>
                    }
                    key="3"
                  >
                    <div>
                      <p>Σε περίπτωση απόρριψης της επένδυσης σου, 
                        θα λάβεις ενημέρωση μέσω των στοιχείων επικοινωνίας που έχεις καταχωρήσει στην πλατφόρμα, 
                        σχετικά με τους λόγους απόρριψης. Στη συνέχεια, μπορείς να προβείς σε εκ νέου υποβολή επένδυσης, 
                        αφού πραγματοποιήσεις τις απαραίτητες διορθώσεις.</p>
                    </div>
                  </Panel>
                </Collapse>

                <Collapse
                  key="4"
                  className="main-content__collapse"
                  expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                  expandIconPosition={'right'}
                  onChange={e =>
                    activeKey === '4' ? setActiveKey('') : setActiveKey('4')
                  }
                  activeKey={activeKey}
                >
                  <Panel
                    header={
                      <text className='panel-header-title'>Ποια είναι τα απαιτούμενα δικαιολογητικά για την αίτησή μου;</text>
                    }
                    key="4"
                  >
                    <div>
                      <p>
                        Για την δημιουργία του επενδυτικού σχεδίου της εταιρείας σας χρειάζεται να συνδεθείτε μέσω Taxis Login 
                        και στη συνέχεια να εισάγετε τις δαπάνες που επιθυμείτε να πραγματοποιήσετε. 
                        Λοιπά στοιχεία για την ολοκλήρωση της υποβολής της αίτησης θα απαιτηθούν 
                        σύμφωνα με την σχετική πρόσκληση της τράπεζας που θα επιλεγεί.
                      </p>
                    </div>
                  </Panel>
                </Collapse>

                <Collapse
                  key="5"
                  className="main-content__collapse"
                  expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                  expandIconPosition={'right'}
                  onChange={e =>
                    activeKey === '5' ? setActiveKey('') : setActiveKey('5')
                  }
                  activeKey={activeKey}
                >
                  <Panel
                    header={
                      <text className='panel-header-title'>
                        Πώς διασφαλίζεται η προστασία των δεδομένων μου;
                      </text>
                    }
                    key="5"
                  >
                    <div>
                      <p>
                        Προκειμένου να εκδοθεί το Voucher, θα πρέπει να
                        ακολουθηθούν τα παρακάτω βήματα:
                      </p>
                      <p>
                        Ωφελούμενοι:
                        <ol>
                          <li>
                            Να κάνουν εισαγωγή στην πλατφόρμα και υποβολή αίτησης
                          </li>
                          <li>
                            Εφόσον εγκριθεί τελικώς η αίτηση και λάβουν το κουπόνι στο <b>e-mail </b>  
                            τους μπορούν να απευθυνθούν σε προμηθευτή ώστε να διαλέξουν 
                            εξοπλισμό και υπηρεσίες.
                          </li>
                        </ol>
                      </p>
                      <p>
                        Προμηθευτές:
                        <ol>
                          <li>
                            Θα πρέπει να κάνουν την εγγραφή τους στο Μητρώο
                            Προμηθευτών και να δηλώσουν τον εξοπλισμό τους
                          </li>
                          <li>
                            Εφόσον η αίτηση εγκριθεί πλέον μπορούν να εισέλθουν
                            και στην πλατφόρμα του προγράμματος.
                          </li>
                        </ol>
                      </p>
                    </div>
                  </Panel>
                </Collapse>

                <Collapse
                  key="6"
                  className="main-content__collapse"
                  expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                  expandIconPosition={'right'}
                  onChange={e =>
                    activeKey === '6' ? setActiveKey('') : setActiveKey('6')
                  }
                  activeKey={activeKey}
                >
                  <Panel
                    header={
                      <text className='panel-header-title'>Ποια είναι η μέγιστη διάρκεια αποπληρωμής του δανείου;</text>
                    }
                    key="6"
                  >
                    <div>
                      <p>Η διάρκεια αποπληρωμής του δανείου είναι έως 10 έτη.</p>
                    </div>
                  </Panel>
                </Collapse>

                <Collapse
                  key="7"
                  className="main-content__collapse"
                  expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                  expandIconPosition={'right'}
                  onChange={e =>
                    activeKey === '7' ? setActiveKey('') : setActiveKey('7')
                  }
                  activeKey={activeKey}
                >
                  <Panel
                    header={
                      <text className='panel-header-title'>Πώς κατανέμεται η χρηματοδότηση των Δανείων ΤΑΑ;</text>
                    }
                    key="7"
                  >
                    <div>
                      <p>Το 50% του κόστους της επένδυσης σου δύναται να χρηματοδοτηθεί με χαμηλότοκο δάνειο 
                        μέσω του ΤΑΑ, το 30%, τουλάχιστον, με εμπορικό δάνειο και το 20%, τουλάχιστον, με Ίδια Κεφάλαια.</p>
                    </div>
                  </Panel>
                </Collapse>
              </div>
            </div>
          </div>

        </div>
      </Content>
      <div className="landing-page-footer-smart">
        <Footer />
      </div>
    </Layout>
  );
};

export default StaticPage1;
